import { Typography } from '@mui/material'
import { limitCharacters } from 'src/utils/formatString'
import { useSelector } from 'src/utils/store'
import { SwapOrReturnTypeIds, TypeActionTextEnum } from '../../SwapOrReturnTypes'
import { getReceivementAgreementInfo } from 'src/utils/getReceivementAgreementInfo'
import { InfoReturnOptions } from 'src/features/receivement/ReceivementTypes'
import theme from 'src/styles/theme'
import * as S from './InfoRequestCard.styles'

interface InfoRequestCardProps {
  info: InfoReturnOptions
  readOnly: boolean
}

const InfoRequestCard: React.FC<InfoRequestCardProps> = ({ info, readOnly }) => {
  const { requestTypeId, typeAction, swapOrReturnData } = useSelector((state) => state.swapOrReturn)

  const defineCurrentAction = () => {
    if (readOnly) {
      return { backgroundColor: theme.colors.gray6, typeActionText: TypeActionTextEnum.READ_ONLY }
    }

    if (requestTypeId === SwapOrReturnTypeIds.RETURN) {
      const typeActionText = typeAction === 'CREATE' ? TypeActionTextEnum.CREATE_RETURN : TypeActionTextEnum.EDIT_RETURN
      return { backgroundColor: theme.colors.orange, typeActionText }
    }

    const typeActionText = typeAction === 'CREATE' ? TypeActionTextEnum.CREATE_SWAP : TypeActionTextEnum.EDIT_SWAP
    return { backgroundColor: theme.colors.lightBlue5, typeActionText }
  }

  const { backgroundColor, typeActionText } = defineCurrentAction()
  const { infoSupplier } = getReceivementAgreementInfo(info)

  return (
    <S.Container
      data-testid='info-request-card-test-id'
    >
      <S.Row>
        <Typography variant='subtitle2' fontWeight={600}>Chave NF:</Typography>
        <Typography variant='subtitle2'>{swapOrReturnData.invoiceKey}</Typography>
      </S.Row>
      <S.Row>
        <Typography variant='subtitle2' fontWeight={600}>Número NF:</Typography>
        <Typography variant='subtitle2'>{swapOrReturnData.invoiceNumber}</Typography>
      </S.Row>
      <S.Row>
        <Typography variant='subtitle2' fontWeight={600}>Nome fornecedor: </Typography>
        <Typography variant='subtitle2'>{limitCharacters(swapOrReturnData.supplierName || '', 44)}</Typography>
      </S.Row>
      <Typography variant='subtitle2' fontWeight={600}>Fornecedor {infoSupplier}</Typography>
      <S.Action backgroundColor={backgroundColor}>{typeActionText}</S.Action>
    </S.Container>
  )
}

export default InfoRequestCard
